<template>
  <Transition name="valid-riddle-transition">
    <p v-if="visible" :class="['riddle__error', { '--max': max }]">{{ message }}</p>
  </Transition>
</template>

<script>
export default {
  name: 'RiddleError',
  props: {
    max: {
      type: Boolean,
      required: true,
    },
    validAnswer: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    message() {
      return this.max
        ? this.$beet.options.hunt.labels.riddle.limit.replace('[ANSWER]', this.validAnswer)
        : this.$beet.options.hunt.labels.riddle.invalid
    },
  },
}
</script>
